// extracted by mini-css-extract-plugin
module.exports = {"text":"VIN_text__2Tx1y FormField_text__3CRh7 font_normal__3xTtI"};